import { headingXs } from '@insify/design-system/typography';
import { type ChangeEventHandler } from 'react';

import { AddOn } from '../../../../components/AddOn';
import { useCoveragesForm, useCoveragesPremiums } from '../../useCoveragesForm';

import * as styles from './AddOns.module.css';

import type { AddOnProps } from '../../../../components/AddOn';

export const AddOns = ({ addOns, heading }: { addOns: AddOnProps[]; heading?: string }) => {
  const {
    onToggle,
    coveragesFormMethods: { register },
  } = useCoveragesForm();

  const { isLoading } = useCoveragesPremiums();

  return (
    <div className={styles.addOns}>
      <div className={headingXs}>{heading}</div>
      {addOns.map((addOn) => {
        const toggleEventHandler: ChangeEventHandler<HTMLInputElement> = (value) =>
          onToggle({
            type: addOn.name,
            enabled: value.target.checked,
          });

        return (
          <AddOn
            {...addOn}
            key={addOn.id}
            {...register(addOn.name, {
              onChange: (event) => {
                toggleEventHandler(event);
              },
              shouldUnregister: true,
              disabled: isLoading,
            })}
          />
        );
      })}
    </div>
  );
};
